import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
export function ScarcityHeader() {
  return <section className="w-full bg-slate-900 py-12 px-4 flex flex-col items-center text-center" data-id="element-24">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.5,
      type: 'spring'
    }} data-id="element-25">
        <AlertTriangle className="w-16 h-16 md:w-20 md:h-20 text-yellow-400 mb-4" data-id="element-26" />
      </motion.div>

      <motion.h2 initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.2
    }} className="text-4xl md:text-5xl font-extrabold text-white mb-8 tracking-tight" data-id="element-27">
        ¡ESPERÁ!
      </motion.h2>

      <div className="w-full max-w-md mx-auto" data-id="element-28">
        <div className="relative w-full h-4 bg-slate-700 rounded-full overflow-hidden mb-3" data-id="element-29">
          <div className="absolute top-0 left-0 h-full w-1/2 bg-blue-500 rounded-full overflow-hidden" data-id="element-30">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-31" />
          </div>
        </div>
        <p className="text-slate-400 text-sm font-medium" data-id="element-32">
          Tu pedido está completado al 50%...
        </p>
      </div>
    </section>;
}